// src/contexts/LoadingContext.js

import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const show = useCallback(() => setCount(n => n + 1), []);
  const hide = useCallback(() => setCount(n => Math.max(0, n - 1)), []);

  return (
    <LoadingContext.Provider value={{ isLoading: count > 0, show, hide }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const ctx = useContext(LoadingContext);
  if (!ctx) throw new Error('useLoading must be used inside LoadingProvider');
  return ctx;
};
